import api from "@/api";
import Vue from "vue";

export default {
	actions: {
		async GetNewsList(_, newsType = "AllType") {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetNewsList + newsType,
			});
			return response;
		},
		async GetLatestNewsList(_, newsType = "AllType") {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetLatestNewsList + newsType,
			});
			return response;
		},
		async GetNews(_, entryId) {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetNews + entryId,
				data: entryId,
			});
			return response;
		},
		async CreateNews(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.CreateNews,
				data: entry,
			});

			return response;
		},
		async UpdateNews(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.UpdateNews,
				data: entry,
			});
			return response;
		},
		async DeleteNews(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.DeleteNews,
				data: entry,
			});
			return response;
		},
	},
};
